export interface HaygentSession {
  session_id: string;
  name: string;
}

export interface HaygentMessage {
  role: 'user' | 'assistant';
  content: string;
}

export interface HaygentStreamChunk {
  content: string;
  done: boolean;
}

export enum HaygentChatState {
  Collapsed = 'collapsed',
  Docked = 'docked',
  Maximized = 'maximized',
}
